export default __webpack_public_path__ + "static/media/image 45.fab78fd2.png";